import axios, { AxiosResponse } from "axios";

import { postRequest } from "@/Utils/Service/BackendService";

import {
	AuthToken,
	EmailVerificationResponse,
	LoginRequest,
	ResendEmailVerificationRequest,
	SignupRequest
} from "@/Contracts/Login";
import { UserData } from "@/Contracts/Users";

const loginUrl = "/v2/users/login";
const signupUrl = "/v2/users/signup";
const resendVerifyEmailUrl = "/v2/users/email/verify";
const resendPasswordlessEmailUrl = "/v2/users/passwordless/resend";

export const login = async (loginRequest: LoginRequest): Promise<AuthToken> => {
	try {
		const response: AxiosResponse<AuthToken> = await axios(
			postRequest(loginUrl, loginRequest, false, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const signup = async (
	signupRequest: SignupRequest
): Promise<UserData> => {
	try {
		const response: AxiosResponse<UserData> = await axios(
			postRequest(signupUrl, signupRequest, false, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const resendVerifyEmail = async (
	resendEmailVerificationRequest: ResendEmailVerificationRequest
): Promise<EmailVerificationResponse> => {
	try {
		const response: AxiosResponse<EmailVerificationResponse> = await axios(
			postRequest(
				resendVerifyEmailUrl,
				resendEmailVerificationRequest,
				false,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const resendPasswordlessEmail = async (
	resendPasswordlessEmailVerificationRequest: ResendEmailVerificationRequest
): Promise<EmailVerificationResponse> => {
	try {
		const response: AxiosResponse<EmailVerificationResponse> = await axios(
			postRequest(
				resendPasswordlessEmailUrl,
				resendPasswordlessEmailVerificationRequest,
				false,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};
